import React, { FunctionComponent } from 'react';
import type { TvDetail } from '../../../types/tvShow';
import { YoutubeEmbed } from '../../atoms/youtubeEmbed';

type Props = {
  tv: TvDetail;
  currentUser: boolean;
  lineIcon: string;
};

export const Presentation: FunctionComponent<Props> = ({
  tv,
  currentUser,
  lineIcon
}) => {
  return (
    <div className="tv-content-top">
      <YoutubeEmbed
        embedUrl={`https://www.youtube.com/embed/${tv.url.slice(-11)}?rel=0`}
        isLoggedIn={currentUser}
        lineIcon={lineIcon}
      />
      <div className="tv-content-top-info">
        <h1 className="tv-content-top-info-title">{tv.title}</h1>
        <div className="tv-content-top-info-detail">
          <div className="tv-content-top-info-names">
            <p className="tv-content-top-info-company">{tv.companyName}</p>
            <div className="tv-content-top-info-tags">
              {tv.tvTags.map((tag) => (
                <a
                  key={tag}
                  href={`/tvs/search?keyword=${encodeURIComponent(tag)}`}
                  className="tv-content-top-info-tags-link gtm-tv_tag-view-count"
                  data-event-name='tv_tag on screen'
                  data-event="click"
                  data-category="tvcontent"
                  data-value="tag"
                >
                  {tag}
                </a>
              ))}
            </div>
          </div>
          <p className="tv-content-top-info-date">{tv.updatedAt}</p>
        </div>
      </div>
    </div>
  );
};
